class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);


document.addEventListener("DOMContentLoaded", (event) => {
  initFilters();
});
  
initCartLink();

function initCartLink() {
  document.addEventListener("click", function(e) {
    if (e.target && e.target.matches('[data-cart-link]')) {
      window.location.href = '/cart';
    }
  });
}

function initFilters() {
  let openers = document.querySelectorAll('[data-filters-opener]');
  let filterOpeners = document.querySelectorAll('[data-filter-opener]');
  let filters = document.getElementById('filters_bar');
  const openedClass = 'show';
  const drawerOpened = 'drawer-opened';

  openers.forEach(opener => {
    opener.addEventListener('click', function () {
      if (filters.classList.contains(openedClass)) {
        filters.classList.remove(openedClass);
        document.body.classList.remove(drawerOpened);

        setTimeout(function () {
          filters.querySelectorAll('.'+openedClass).forEach(fo => {
            fo.classList.remove(openedClass);
          });
        }, 150);
      } else {
        filters.classList.add(openedClass);
        document.body.classList.add(drawerOpened);
      }
    });
  });

  filterOpeners.forEach(filterOpener => {
    let openerTarget = document.getElementById(filterOpener.dataset.filterOpener);

    filterOpener.addEventListener('click', function () {
      if (openerTarget.classList.contains(openedClass)) {
        openerTarget.classList.remove(openedClass);
      } else {
        openerTarget.classList.add(openedClass);
      }
    });
  });
}